export const NON_CORE_CATEGORY = 'Non core & common value';

const TA_ARCHETYPE_PATTERN = /^TA Archetype (\d+)$/;

/**
 * Rank of a raw `ta_archetype` value for ascending sort.
 * `TA Archetype 1`..`N` -> its number; `N/A`, unknown, or nullish -> sorts last.
 */
export const getTaArchetypeRank = (archetype: string | null | undefined): number => {
  const match = archetype ? TA_ARCHETYPE_PATTERN.exec(archetype) : null;
  return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER;
};

/** Category (core product name) rank: normal groups first (0), the non-core group last (1). */
export const getCategoryRank = (coreProductName: string | null | undefined): number =>
  coreProductName === NON_CORE_CATEGORY ? 1 : 0;

/** Comparator: core product names alphabetically, with the non-core group pushed to the bottom. */
export const compareTaArchetypeGroups = (a: string, b: string): number => {
  const rankDiff = getCategoryRank(a) - getCategoryRank(b);
  return rankDiff !== 0 ? rankDiff : a.localeCompare(b);
};
